/**
 * useComplianceRules — abstraction over the compliance rule source.
 *
 * Phase 1: returns the centralised DEFAULT_COMPLIANCE_RULES constant.
 * Phase 2 (future): will read from `org_compliance_rules` and fall back
 * to defaults so multi-tenant overrides become possible without any
 * consumer change.
 */
import { DEFAULT_COMPLIANCE_RULES, type ComplianceRule } from "@/lib/complianceRules";

export function useComplianceRules(_orgId?: string | null): ComplianceRule[] {
  // Phase 2 stub: useQuery(['compliance-rules', orgId], ...) ?? DEFAULT_COMPLIANCE_RULES
  return DEFAULT_COMPLIANCE_RULES;
}
